'use client';

import { useDigitalData, usePdpFindMethod, useViewItem, useViewSearchResults } from '../../model/analytics';

export function Analytics() {
    useViewItem();
    useViewSearchResults();
    usePdpFindMethod();
    useDigitalData();

    return null;
}
